import React from 'react';
import PropTypes from 'prop-types';

const MappingErrorNotification = ({ summaries, errors }) => {
  const summaryDiv = (summaries) ? (
    <div className="mapping-msg__summary">
      {summaries.map(summary => <div key={summary} className="summary">{summary}</div>)}
    </div>
  ) : null;
  const errorDiv = (errors) ? (
    <div className="mapping-msg__errors">
      {errors.map(error => <div key={error} className="error">{error}</div>)}
    </div>
  ) : null;
  return (
    <>{summaryDiv}{errorDiv}</>
  );
};

MappingErrorNotification.propTypes = {
  summaries: PropTypes.arrayOf(PropTypes.string).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MappingErrorNotification;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/MappingErrorNotification.jsx